import { getHostingHookPlanId } from "~/lib/config"
import { STORAGE } from "~/lib/storage"
import SessionStorage from "~/lib/storage/SessionStorage"
import type { BasketAction } from "~/store/basket/actions"
import { BasketActions } from "~/store/basket/constants"
import { getLastItemsFromBasket } from "~/store/basket/utils"

const middleware = () => (next) => (action: BasketAction) => {
  if (action.type === BasketActions.BASKET_SUCCESS) {
    const addedItems = getLastItemsFromBasket(action.result)

    const hasHostingHookProduct = addedItems.some(
      (item) => "plan_id" in item && item.plan_id === getHostingHookPlanId()
    )

    if (hasHostingHookProduct) {
      SessionStorage.setBool(STORAGE.DOMAIN_HOOK_ADDED_TO_BASKET, true)
    }
  }

  return next(action)
}

export default middleware
